import { Strings } from './strings.utils';
import { CryptoService } from '@shared/core/services/crypto.shared.service';

export class Storage {
    private static _cryptoService = new CryptoService();

    public static set(name: string, value: number | null | undefined | string | { [key: string]: any } | any[], storageType: string = 'localStorage'): boolean {
        try {
            window[storageType].setItem(name, Strings.toString(value));

            return true;
        } catch (ex) {
            console.error(ex);

            return false;
        }
    }

    public static getItem(name: string, storageType: string = 'localStorage'): string | null {
        try {
            return window[storageType].getItem(name);
        } catch (ex) {
            console.error(ex);

            return null;
        }
    }

    public static getEncryptedItem(name: string, storageType: string = 'localStorage'): Nullable<JsonParseValue> {
        let item = this.getItem(name, storageType);

        return this._decryptAndParseItem(item);
    }

    private static _decryptAndParseItem(item: string): Nullable<JsonParseValue> {
        if (!item) {
            return null;
        }

        try {
            const decryptedItem = this._cryptoService.decrypt(item);

            return decryptedItem ? JSON.parse(decryptedItem) : null;
        } catch (e) {
            console.error('Error decrypting or parsing item:', e);

            return null;
        }
    }

    public static remove(name: string, storageType: string = 'localStorage'): boolean {
        try {
            window[storageType].removeItem(name);

            return true;
        } catch (ex) {
            console.error(ex);

            return false;
        }
    }

    public static clear(storageType: string = 'localStorage'): boolean {
        try {
            window[storageType].clear();

            return true;
        } catch (ex) {
            console.error(ex);

            return false;
        }
    }

    public static clearByCategory(category: string, storageType: string = 'localStorage'): boolean {
        try {
            const keys = Object.keys(window[storageType]);
            keys.forEach((key: string) => {
                if (key.startsWith(category)) {
                    window[storageType].removeItem(key);
                }
            });

            return true;
        } catch (ex) {
            console.error(ex);

            return false;
        }
    }
}
